import Vue from 'vue';
import $ from 'jquery';
function hasClass(obj, cls) {
  return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

let fn = {
  linkQq: {
    bind: function (el, binding, vnode) {
      let qqNum = binding.expression || '2851207386',
        link = 'mqqwpa://im/chat?chat_type=wpa&uin=' + qqNum + '&version=1&src_type=web&web_src=oicqzone.com';
      if (el.localName == 'a') {
        el.href = link;
        el.target = '_blank';
      } else {
        el.addEventListener('click', function () {
          window.open(link);
        });
      }
    }
  },
  playerAnimate: {
    bind: function (el, binding, vnode) {
      let timer,
        interval = 2500;
      el.addEventListener('click', () => {
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
          if (hasClass(el, 'on')) {
            var reg = new RegExp('(\\s|^)' + 'on' + '(\\s|$)');
            el.className = el.className.replace(reg, ' ');
          }
        }, interval);
      });
    }
  },
  jqTips: {
    bind: function (el, binding, vnode) {
      let $el = $(el);
      $el.data('tips', binding.value || '');
      $el.hover(
        () => {
          let str = $el.data('tips');
          str && $el.tips(str);
        },
        () => {
          $.tips();
        }
      );
    },
    componentUpdated: function (el, binding, vnode) {
      $(el).data('tips', binding.value);
    }
  },
  // 重复点击间隔
  interval: {
    bind: function (el, binding, vnode) {
      // 间隔事件
      let interval = binding.expression || 1000,
        lock = false,
        $el = $(el);
      el.addEventListener('click', () => {
        $el.css('pointer-events', 'none');
        setTimeout(() => {
          $el.css('pointer-events', '');
        }, interval);
      });
    }
  },

  // 捕获组件外点击事件
  clickoutside: {
    bind: function (el, binding, vnode) {
      el.externalClick = function (event) {
        if (event.target !== el && !el.contains(event.target)) {
          binding.value && binding.value();
        }
      };
      document.body.addEventListener('click', el.externalClick);
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.externalClick);
    }
  }
};

for (let key in fn) {
  Vue.directive(key, fn[key]);
}



// WEBPACK FOOTER //
// ./src/directive/directives.js